import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { IActiveList } from '@modules/private/active/data/interfaces/iactive.interface';
import { IResponseArray } from '@data/interfaces/iresponseArray.interface';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiAssetsService extends ApiClass {
  id!: string

  constructor() {
    super()
    this.path = 'assets'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    const response: IActiveList = {
      error: true,
      msg: '',
      data: [],
      total: 0,
      status: 200,
      page: 1,
      itemsByPage: 10,
      totalItems: 0
    }

    filters = {
      client: { value: this.id, matchMode: 'equals' }
    }

    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters }).pipe(
      map((r) => r as IActiveList),
      catchError((e) => of(response))
    )
  }
}
